export default "__VITE_ASSET__zmD8Xu2O__"